var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, customElement, property } from "lit-element";
import { Badge, NumberBadge, TextBadge } from "./abstract";
let StatusBadge = class StatusBadge extends TextBadge {
    getClass() {
        if (this.value == "Ready")
            return this.BADGE_SUCCESS;
        return this.BADGE_DANGER;
    }
};
StatusBadge = __decorate([
    customElement('status-badge')
], StatusBadge);
let FeederBadge = class FeederBadge extends NumberBadge {
    getClass() {
        if (this.value > 10)
            return this.BADGE_SUCCESS;
        if (this.value > 5)
            return this.BADGE_WARNING;
        return this.BADGE_DANGER;
    }
};
FeederBadge = __decorate([
    customElement('feeder-badge')
], FeederBadge);
let RibbonBadge = class RibbonBadge extends TextBadge {
    getClass() {
        const ribbonState = parseInt(this.value.split("/")[0].trim());
        if (ribbonState > 20)
            return this.BADGE_SUCCESS;
        if (ribbonState > 1)
            return this.BADGE_WARNING;
        return this.BADGE_DANGER;
    }
};
RibbonBadge = __decorate([
    customElement('ribbon-badge')
], RibbonBadge);
let ValidationsBadge = class ValidationsBadge extends NumberBadge {
    getClass() {
        if (this.value < 250)
            return this.BADGE_SUCCESS;
        if (this.value < 300)
            return this.BADGE_WARNING;
        return this.BADGE_DANGER;
    }
};
ValidationsBadge = __decorate([
    customElement('validations-badge')
], ValidationsBadge);
let ConnectionBadge = class ConnectionBadge extends Badge {
    render() {
        const statusTime = new Date(this.timestamp).getTime();
        const timeDifferenceMinutes = (new Date().getTime() - statusTime) / 1000 / 60;
        if (timeDifferenceMinutes < this.freshnessTimeoutMinutes) {
            return html `<span class=${this.BADGE_SUCCESS}>Status is up to date</span>`;
        }
        else {
            return html `<span class=${this.BADGE_WARNING}>Warning! Status may be old, check timestamp!</span>`;
        }
    }
};
__decorate([
    property()
], ConnectionBadge.prototype, "freshnessTimeoutMinutes", void 0);
__decorate([
    property()
], ConnectionBadge.prototype, "timestamp", void 0);
ConnectionBadge = __decorate([
    customElement('connection-badge')
], ConnectionBadge);
